import ReactGA from "react-ga4";

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const initGA = () => {
    if (MEASUREMENT_ID) {
        ReactGA.initialize(MEASUREMENT_ID);
    } else {
        console.warn("Google Analytics Measurement ID not found");
    }
};

export const trackPageView = (path) => {
    ReactGA.send({ hitType: "pageview", page: path });
};
